import { clientApp } from './index';

export const checkSubscription = () => clientApp.get(`/ui/dpd/subscription`);

export const postCheckout = () =>
  clientApp.post(`/ui/dpd/subscription/checkout`, { url: process.env.REACT_APP_FE_URL + '/admin/delivery' });
